<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <h4 class="card-title mb-0">Total</h4>
                    </CCardHeader>
                    <CCardBody>
                        <WidgetsTotal ref="totals" :items="totalItems"/>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <h4 class="card-title mb-0">Today</h4>
                    </CCardHeader>
                    <CCardBody>
                        <WidgetsTotal ref="today" :items="todayItems"/>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CRow >
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <h4 class="card-title mb-0">Drivers</h4>
                    </CCardHeader>
                    <CCardBody>
                        <div class="row justify-content-end align-items-center">
                            <div class="col-auto pr-0">
                                <div class="d-flex flex-row">
                                    <div class="mr-2 my-auto">
                                        <label>{{ $t('to') }}:</label>
                                    </div>
                                    <div class="mr-2 my-auto">
                                        <input type="date" v-model="to" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="col-auto pr-0">
                                <CButton color="primary" @click="getDrivers">
                                    <CIcon :content="$options.filterIcon" /> {{ $t('filter') }}
                                </CButton>
                            </div>
                            <div class="col-auto pr-0">
                                <CButton color="primary" @click="clearFilters">
                                    <CIcon :content="$options.clearIcon" /> {{ $t('clear') }}
                                </CButton>
                            </div>
                            <div class="col-12">
                                &nbsp;
                                <br>
                            </div>
                        </div>
                        <CDataTable
                            :items="items"
                            :fields="fields"
                        >
                        </CDataTable>
                    </CCardBody>  
                </CCard>
            </CCol>
        </CRow>
        <CRow >
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <h4 class="card-title mb-0">Delivery Type</h4>
                    </CCardHeader>
                    <CCardBody>
                        <div class="row justify-content-end align-items-center">
                            <div class="col-auto pr-0">
                                <div class="d-flex flex-row">
                                    <div class="mr-2 my-auto">
                                        <label>{{ $t('to') }}:</label>
                                    </div>
                                    <div class="mr-2 my-auto">
                                        <input type="date" v-model="toType" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="col-auto pr-0">
                                <CButton color="primary" @click="getTypes">
                                    <CIcon :content="$options.filterIcon" /> {{ $t('filter') }}
                                </CButton>
                            </div>
                            <div class="col-auto pr-0">
                                <CButton color="primary" @click="clearFiltersType">
                                    <CIcon :content="$options.clearIcon" /> {{ $t('clear') }}
                                </CButton>
                            </div>
                            <div class="col-12">
                                &nbsp;
                                <br>
                            </div>
                        </div>
                        <CDataTable
                            :items="itemsType"
                            :header="false"
                        >
                        </CDataTable>
                    </CCardBody>  
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import axios from 'axios';
import MainChartExample from './charts/MainChartExample';
import WidgetsTotal from './widgets/WidgetsTotal';
import WidgetsBrand from './widgets/WidgetsBrand';
import authMixin from "../mixins/auth";
import i18n from "../i18n";
import { cilFilter } from '@coreui/icons';

export default {
    name: 'Dashboard',
    filterIcon: cilFilter,
    components: {
        MainChartExample,
        WidgetsTotal,
        WidgetsBrand
    },
    mixins: [authMixin],
    data () {
        return {
            items: [],
            itemsType: [],
            to: '',
            toType: '',
            fields: [
                {
                    key: 'name',
                    label: i18n.t('fields.name')
                }, 
                {
                    key: 'bottles_dispatched',
                    label: i18n.t('fields.bottles_dispatched')
                }, 
                {
                    key: 'ordered_bottles',
                    label: i18n.t('fields.ordered_bottles')
                }, 
                {
                    key: 'bottles_sold',
                    label: i18n.t('fields.bottles_sold')
                }, 
                {
                    key: 'remaining_bottles',
                    label: i18n.t('fields.remaining_bottles')
                }, 
                {
                    key: 'price_total',
                    label: i18n.t('fields.totals')
                }, 
                {
                    key: 'date',
                    label: i18n.t('fields.date')
                }, 
            ],
            tableFilter: {
                label: "Buscar:",
                placeholder: "Por nombre",
                lazy: false,
                external: true
            },
            selected: 'Month',
            tableFields: [
                { key: 'avatar', label: '', _classes: 'text-center' },
                { key: 'user' },
                { key: 'country', _classes: 'text-center' },
                { key: 'usage' },
                { key: 'payment', label: 'Payment method', _classes: 'text-center' },
                { key: 'activity' },
            ],
            totalItems: [],
            todayItems: []
        }
    },
    mounted() {
        this.loadDashboard();
        this.getDrivers();
        this.getTypes();
    },
    methods: {
        getDrivers() {
            var url = '';

            if (this.to != '')
            url = '/api/dashboard-driver?date_time='+this.to +'&token=' + localStorage.getItem("api_token");
            else
            url = '/api/dashboard-driver?token=' + localStorage.getItem("api_token");

            axios.get(url)
                .then(response => {
                    this.items = response.data;
                }).catch(error => {
                    console.log(error);
                    this.showAlertError();
                });
        },
        getTypes() {
            var url = '';

            if (this.toType != '')
            url = '/api/dashboard-types?date_time='+this.toType +'&token=' + localStorage.getItem("api_token");
            else
            url = '/api/dashboard-types?token=' + localStorage.getItem("api_token");

            axios.get(url)
                .then(response => {
                    this.itemsType = response.data;
                }).catch(error => {
                    console.log(error);
                    this.showAlertError();
                });
        },
        filteredItems() {
            return this.items.filter(i => {
                return i.name.toLowerCase().includes(this.search.toLowerCase());
            });
        },
        color (value) {
            let $color
            if (value <= 25) {
                $color = 'info'
            } else if (value > 25 && value <= 50) {
                $color = 'success'
            } else if (value > 50 && value <= 75) {
                $color = 'warning'
            } else if (value > 75 && value <= 100) {
                $color = 'danger'
            }
            return $color
        },
        clearFilters() {
            this.to = '';
            this.getDrivers();
        },
        clearFiltersType() {
            this.toType = '';
            this.getTypes();
        },
        showAlertError() {
            if (this.message != "") {
                this.$swal({
                    title: i18n.t('modal.title'),
                    text: this.message,
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonColor: '#d33',
                });
            } else {
                this.$swal({
                    title: i18n.t('modal.title'),
                    text: i18n.t('modal.body'),
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonColor: '#d33',
                });
            }
        },
        loadDashboard() {
            axios.get( '/api/dashboard?token=' + localStorage.getItem("api_token"))
                .then(response => {
                    this.totalItems = response.data.general;
                    this.todayItems = response.data.today;
                }).catch(function (error) {
                    console.log(error);
                    if (error.response.status === 401) {
                        this.$router.push({ path: '/login' });
                    }
                });

        }
    }
}
</script>
